import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inline: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-evenly",
    },
    root: {
      maxWidth: 320,
      alignSelf: "center",

      "&.dnf": {
        maxWidth: 370,
        padding: "1rem 2rem",
      },
    },
    avatar: {
      fontSize: 22,
      fontWeight: "bold",
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.dark,
    },
    avatar2: {
      fontSize: 15,
      fontWeight: "bold",
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.grey[900],
    },
    clearButtonAvatar: {
      backgroundColor: "#cc2c1c",
      fontSize: 10,
    },
    clearButton: {
      position: "absolute",
      left: 8,
      top: -6,
    },
    embedded: {
      width: "100%",
      maxWidth: 430,
      margin: "0 auto",
    },
    embeddedClear: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      minHeight: 44,
      margin: "0 0 10px",
      padding: "0 12px",
      border: "none",
      borderRadius: 8,
      backgroundColor: "#c62828",
      color: "#fff",
      fontSize: "0.875rem",
      fontWeight: 700,
      letterSpacing: "0.06em",
      fontFamily: "inherit",
      cursor: "pointer",
      WebkitAppearance: "none",
      appearance: "none",
      transition: "transform 0.12s cubic-bezier(0.23, 1, 0.32, 1)",
      "&:hover": {
        backgroundColor: "#b71c1c",
      },
      "&:active": {
        transform: "scale(0.97)",
      },
      "&:focus-visible": {
        outline: "2px solid rgba(94, 53, 177, 0.5)",
        outlineOffset: 2,
      },
      "@media (prefers-reduced-motion: reduce)": {
        transition: "none",
        "&:active": {
          transform: "none",
        },
      },
    },
    embeddedGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
      gap: 8,
    },
    embeddedKey: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: 48,
      minHeight: 48,
      margin: 0,
      padding: 0,
      border: "none",
      borderRadius: 10,
      fontFamily: "inherit",
      fontVariantNumeric: "tabular-nums",
      cursor: "pointer",
      WebkitAppearance: "none",
      appearance: "none",
      boxSizing: "border-box",
      transition: "transform 0.12s cubic-bezier(0.23, 1, 0.32, 1)",
      "&:active": {
        transform: "scale(0.97)",
      },
      "&:focus-visible": {
        outline: "2px solid rgba(94, 53, 177, 0.5)",
        outlineOffset: 2,
      },
      "@media (prefers-reduced-motion: reduce)": {
        transition: "none",
        "&:active": {
          transform: "none",
        },
      },
    },
    embeddedKeyNumber: {
      fontSize: "1.25rem",
      fontWeight: 700,
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.dark,
    },
    embeddedKeyPager: {
      fontSize: "0.9375rem",
      fontWeight: 600,
      letterSpacing: "0.04em",
      color: theme.palette.primary.dark,
      backgroundColor: "rgba(25, 118, 210, 0.12)",
      border: "1px solid rgba(25, 118, 210, 0.32)",
    },
    pagerAvatar: {
      fontSize: 15,
      fontWeight: 600,
      color: theme.palette.primary.dark,
      backgroundColor: "rgba(25, 118, 210, 0.16)",
    },
    embeddedKeyStatus: {
      fontSize: "0.8125rem",
      fontWeight: 700,
      letterSpacing: "0.04em",
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.grey[900],
    },
  }),
);
